import InputQuery from './input-query-cmp.vue'
export default {
	install: (Vue, opcions) => {
		Vue.component('input-query', InputQuery)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/components/input-query/input-query.js